import styled from '@emotion/styled'
import React from 'react'

interface InputContainerProps {
  modal?: boolean
}

const InputContainer = styled.div<InputContainerProps>`
  position: relative;
  margin: 0;

  input {
    background: transparent;
    border-radius: 6px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    color: #ededed;
    padding: 10px 10px;
    position: relative;
    display: block;
    margin-bottom: 20px;
    min-width: 300px;
    @media only screen and (max-width: 700px) {
      min-width: 150px;
    }
    height: 34px;
    font-family: 'DMSans', sans-serif;
    font-size: 13px;
    transition: border-color 0.15s;

    &:focus {
      border-color: rgba(111, 92, 230, 0.5);
      outline: none;
      box-shadow: 0 0 0 3px rgba(111, 92, 230, 0.1);
    }
  }

  label {
    position: absolute;
    top: 48%;
    left: 12px;
    transform: translateY(-160%);
    transition:
      transform 0.2s ease,
      color 0.2s ease,
      font-size 0.2s ease;
    color: #777 !important;
    background-color: ${({ modal }) => (modal ? '#111' : '#0d0d0d')};
    padding: 0 4px;
    pointer-events: none;
    font-size: 11px;
    font-family: 'DMSans', sans-serif;
    font-weight: 500;
    letter-spacing: 0.03em;
    line-height: 180%;
  }
`

interface CustomInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string
  modal?: boolean
}

const CustomInput: React.FC<CustomInputProps> = ({ label, modal = false, ...props }) => (
  <InputContainer modal={modal}>
    <input {...props} className="nextui-input" placeholder=" " />
    <label>{label}</label>
  </InputContainer>
)

export default CustomInput
